module.exports = __webpack_public_path__ + "3b59e876745dae27677fb26f27860170.svg";